module.exports = __webpack_public_path__ + "img/pro-lab4.921be017.png";